import { Alert, Anchor, Text } from '@zillow/constellation';
import { CreditReport as CreditFile, UserType } from '@zg-rentals/applications-reports';
import type { CreditReportType } from '@zg-rentals/ts-capps-client';
import { APPLICATIONS_FAQ_URL } from '../../../constants/urls';
import { bootstrap } from '../../../bootstrap';
import { useApplicationContextOrUndefined } from '../../../contexts/ApplicationContext';
import { getRentalApplication } from '../../../analytics/getRentalApplication';
import { trackRentalApplicationEvent } from '../../../analytics';

export function CreditReport({
  creditReport,
  requestedDateTime,
  expirationDateTime,
}: {
  creditReport?: CreditReportType;
  requestedDateTime: string;
  expirationDateTime: string;
}) {
  const applicationContext = useApplicationContextOrUndefined();

  return creditReport ? (
    <CreditFile
      userType={UserType.Renter}
      creditReport={creditReport}
      requestedDateTime={requestedDateTime}
      expirationDateTime={expirationDateTime}
      isInMobileWebView={false}
      trackEvent={(clickstreamEvent) => {
        trackRentalApplicationEvent({
          ...clickstreamEvent,
          ...getRentalApplication(applicationContext),
        });
      }}
      emitMetric={(metricName) => bootstrap.monitor.count({ name: metricName })}
    />
  ) : (
    <Alert
      appearance="warning"
      body={
        <Text>
          Report not available. Contact{' '}
          <Anchor href={APPLICATIONS_FAQ_URL} target="_blank" rel="noopener noreferrer">
            customer support
          </Anchor>{' '}
          to report the issue. You can submit your application without the reports.
        </Text>
      }
    />
  );
}
